import $axios from '@/axios-instance.js'

export const addressService = {
  getListData,
  getById,
  getAll,
  getAddressesByCustomerId,
  getAddressesByCustomerIdAndType,
  getAddressesByProjectId,
  getCustomerAddressesByProjectId,
  create,
  createProjectAddress,
  update,
  delete: _delete
}

function getListData (filter, page) {
  return $axios.get(`${process.env.ROOT_API}/addresses`, { params: Object.assign({ currentPage: page }, filter) }).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/addresses/${id}`).then(response => {
    return response.data
  })
}

function getAll () {
  return $axios.get(`${process.env.ROOT_API}/addresses/get-all`).then(response => {
    return response.data
  })
}

function getAddressesByCustomerId (id) {
  return $axios.get(`${process.env.ROOT_API}/addresses/customer/${id}`).then(response => {
    return response.data
  })
}

function getAddressesByCustomerIdAndType (customerId, addressType) {
  return $axios.get(`${process.env.ROOT_API}/addresses/customer/${customerId}/type/${addressType}`).then(response => {
    return response.data
  })
}

function getAddressesByProjectId (id) {
  return $axios.get(`${process.env.ROOT_API}/addresses/project/${id}`).then(response => {
    return response.data
  })
}

function getCustomerAddressesByProjectId (id) {
  return $axios.get(`${process.env.ROOT_API}/addresses/customer-by-project-id/${id}`).then(response => {
    return response.data
  })
}

function create (address) {
  return $axios.post(`${process.env.ROOT_API}/addresses`, address).then(response => {
    return response.data
  })
}

function createProjectAddress (address) {
  return $axios.post(`${process.env.ROOT_API}/addresses/projectaddress`, address).then(response => {
    return response.data
  })
}

function update (address) {
  return $axios.put(`${process.env.ROOT_API}/addresses/${address.addressId}`, address).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/addresses/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/address.service.js